<wcg-dialog title="Session Time Out">
  <div content>
    <p>
      Your session will expire soon due to inactivity. Please click 'Continue
      Session' to keep your session active.
    </p>
    <div class="timer">{{ timeLeft }}</div>
  </div>
  <div secondary data-testid="secondary-button-container">
    <wcg-button
      color="secondary"
      data-testid="continue-button"
      (click)="continueSession()"
    >
      Continue Session
    </wcg-button>
  </div>
  <div primary data-testid="primary-button-container">
    <wcg-button color="primary" data-testid="logout-button" (click)="logout()">
      Logout
    </wcg-button>
  </div>
</wcg-dialog>
